<app-modal
  [open]="open"
  [name]="'step-up'"
  [closeOnBackdrop]="closeOnBackdrop"
  (close)="cancel()"
>
  <div modal-header>Confirm it's you</div>
  <div modal-body>
    <p class="step-up__intro">
      For your security, please re-enter your password to continue.
    </p>
    <div class="form-field">
      <label class="form-label" for="step-up-password">Password</label>
      <input
        id="step-up-password"
        class="input"
        type="password"
        autocomplete="current-password"
        cdkFocusInitial
        data-testid="step-up-password"
        [(ngModel)]="password"
        [attr.aria-invalid]="error ? 'true' : null"
        [attr.aria-describedby]="error ? errorId : null"
        (keyup.enter)="confirm()"
      />
      @if (error) {
        <p class="step-up__error" role="alert" [id]="errorId" data-testid="step-up-error">
          {{ error }}
        </p>
      }
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="step-up-confirm"
    [disabled]="!password.trim() || submitting"
    (click)="confirm()"
  >
    Confirm
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="step-up-cancel"
    [disabled]="submitting"
    (click)="cancel()"
  >
    Cancel
  </button>
</app-modal>
